export const domains = ['foxparadox.pl, localhost', 'coachingninja.pl'];
